import React from 'react';

// local dependencies
import { TableSearchWidget } from 'ui/containers/TableSearchWidget';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { tableSearchInlineWidgetPreloader as TableSearchInlineWidgetPreloader } from 'ui/views/widgets/tableSearchInlineWidget';
import { layoutConfig } from 'config/table-configs/call-log';

const _memberDetailsCommunicationHistoryActionLogWidget = ( props ) => {
    return (
        <div className='ui-member-details-communication-history-action-log-widget'>
            <TableSearchWidget
                layoutConfig = { layoutConfig }
                templateType = 'inline'
                tableResponse = { props.componentData }
                requestPayload={ props.requestPayload }
                onActionClick={ props.onActionClick }
            />
        </div>
    );
};

// set display name
_memberDetailsCommunicationHistoryActionLogWidget.displayName = 'memberDetailsCommunicationHistoryActionLogWidget';

// set default props
_memberDetailsCommunicationHistoryActionLogWidget.defaultProps = {};

// prop types
_memberDetailsCommunicationHistoryActionLogWidget.propTypes = {};


const memberDetailsCommunicationHistoryActionLogWidgetPreloader = ( ) => {
    return (
        <div className='ui-member-details-communication-history-call-log-widget-preloader'>
            <TableSearchInlineWidgetPreloader
                className='ui-member-details-communication-history-call-log-widget-preloader__table-preloader'
            />
        </div>
    );
};

// set display name
memberDetailsCommunicationHistoryActionLogWidgetPreloader.displayName = 'memberDetailsCommunicationHistoryActionLogWidgetPreloader';

// set default props
memberDetailsCommunicationHistoryActionLogWidgetPreloader.defaultProps = {};

// prop types
memberDetailsCommunicationHistoryActionLogWidgetPreloader.propTypes = {};


/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberDetailsCommunicationHistoryActionLogWidget as MemberDetailsCommunicationHistoryActionLogWidget } from 'ui/views/widgets/memberDetailsCommunicationHistoryActionLogWidget';
 *
 * // render
 * <MemberDetailsCommunicationHistoryActionLogWidget propName='propValue'/>
 */
export const memberDetailsCommunicationHistoryActionLogWidget = withNetworkState( memberDetailsCommunicationHistoryActionLogWidgetPreloader, _memberDetailsCommunicationHistoryActionLogWidget );
